export default __webpack_public_path__ + "static/media/germ_rookie_badge_smaller@3x.c0b1855c.png";